"use client";
import BodylineText from "@/components/common/text/bodyline-text";
import ScreenLayout from "@/components/layout/screen-layout";
import { AI_vs_Traditional_Devs_Data } from "@/lib/dto/ai-engineering-squad/ai-vs-traditional-devs-data";
import { IconAiToolOpenai } from "@/lib/images";
import Image from "next/image";

function AI_vs_Traditional_Devs_Section() {
    return (
        <ScreenLayout outerClassName="bg-white">
            <section className="py-16 lg:py-24">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-12 lg:mb-16">
                        <div className="flex justify-center items-center mb-6">
                            <h1
                                className="w-full text-gray-900 leading-tight text-3xl text-center sm:text-3xl md:text-4xl lg:text-5xl xl:text-[55.13px] font-semibold capitalize"
                            >
                                <span className="inline md:block">
                                    Building Without AI Is Like
                                </span>
                                <span className="inline md:hidden"> </span>
                                <span className="inline md:block">
                                    Accounting Without Excel
                                </span>
                            </h1>
                        </div>
                        <BodylineText
                            wrapperClassName="max-w-3xl mx-auto"
                            textClassName="text-gray-600"
                        >
                            {AI_vs_Traditional_Devs_Data.subtitle}
                        </BodylineText>
                    </div>

                    {/* Comparison Table */}
                    <div className="max-w-6xl mx-auto">
                        {/* Comparison Cards */}
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                            {/* Traditional Dev Card */}
                            <div className="bg-red-50 rounded-2xl p-8 border-2 border-red-200">
                                <div className="flex items-center gap-3 mb-6">
                                    <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center">
                                        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <h3 className="text-xl font-bold text-gray-900">Traditional Dev</h3>
                                        <p className="text-gray-600 text-sm">Old school approach</p>
                                    </div>
                                </div>
                                <div className="space-y-4">
                                    {AI_vs_Traditional_Devs_Data.comparison.map((item, index) => (
                                        <div key={index} className="flex items-center gap-3">
                                            <div className="w-6 h-6 bg-red-400 rounded-full flex items-center justify-center flex-shrink-0">
                                                <div className="w-2 h-2 bg-white rounded-full"></div>
                                            </div>
                                            <p className="text-gray-700 leading-relaxed">{item.traditional}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* AI-Adopted Dev Card */}
                            <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-8 border-2 border-green-200">
                                <div className="flex items-center gap-3 mb-6">
                                    <div className="w-12 h-12 rounded-full flex items-center justify-center">
                                        <Image
                                            src={IconAiToolOpenai}
                                            alt="OpenAI Icon"
                                            width={48}
                                            height={48}
                                            className="w-full h-full object-contain rounded-full"
                                        />
                                    </div>
                                    <div>
                                        <h3 className="text-xl font-bold text-gray-900">AI-Adopted Dev</h3>
                                        <p className="text-gray-600 text-sm">Future-ready approach</p>
                                    </div>
                                </div>
                                <div className="space-y-4">
                                    {AI_vs_Traditional_Devs_Data.comparison.map((item, index) => (
                                        <div key={index} className="flex items-center gap-3">
                                            <div className="w-6 h-6 bg-gradient-to-r from-green-500 to-emerald-600 rounded-full flex items-center justify-center flex-shrink-0">
                                                <div className="w-2 h-2 bg-white rounded-full"></div>
                                            </div>
                                            <p className="text-gray-700 leading-relaxed font-medium">{item.ai_adopted}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </ScreenLayout>
    );
}

export default AI_vs_Traditional_Devs_Section; 